import type { CustomerPayment } from '../types/customerPayment';
import { fetchCustomerPaymentPdf } from './customerPaymentApi';
import { printPdfBlob } from './printPdfBlob';

/**
 * Prints the server-generated payment receipt PDF (same document as download/email).
 */
export const printCustomerPayment = async (
  payment: Pick<CustomerPayment, 'id' | 'payment_number'>
): Promise<void> => {
  const { blob } = await fetchCustomerPaymentPdf(
    payment.id,
    `${payment.payment_number}.pdf`
  );
  await printPdfBlob(blob);
};
